module.exports = "img/11.74e6e3.webp";